import { EnumAsUnion } from '~/utils/enum_as_union';

export enum ReportTypes {
  air_quality = 'air_quality',
  aethair_cms_2567 = 'aethair_cms_2567',
  perimeter_monitor = 'perimeter_monitor'
}

export enum ReportAirQualityStandardsTypes {
  airthinx_default = 'airthinx-default',
  air_quality_custom = 'air-quality-custom',
  aethair_crp_default = 'aethair-crp-default',
  airthinx_well_v2 = 'airthinx-well-v2',
  airthinx_cms_2567 = 'airthinx-cms-2567'
}

export enum ReportPerimeterStandardsTypes {
  custom = 'perimeter-custom',
  nys_der_10 = 'nys-der-10',
  nj_pam = 'nj-dep-pam'
}

export enum ReportRunTypes {
  once = 'once',
  scheduled = 'scheduled'
}

export type ReportTypesUnionType = EnumAsUnion<typeof ReportTypes>;
export type ReportTypesRecordType = Record<ReportTypesUnionType, string[]>;
